import * as actions from "./actions";
import { Map, List } from "immutable";

function reducer(
  state = Map({
    isFetching: false,
    items: List(),
  }),
  action
) {
  switch (action.type) {
    // ========= READ ===========
    case actions.QUICK_RESPONSE_READ_SUCCESS:
      return state
        .set("isFetching", false)
        .set("items", List(action.quickResponses));
    case actions.QUICK_RESPONSE_READ_FAILURE:
      return state.set("isFetching", false);
    case actions.QUICK_RESPONSE_READ_REQUEST:
      return state.set("isFetching", true);
    // ======== CREATE ==========
    case actions.QUICK_RESPONSE_CREATE_SUCCESS:
      return state
        .set("isFetching", false)
        .update("items", (list) => list.push(action.quickResponse));
    case actions.QUICK_RESPONSE_CREATE_FAILURE:
      return state.set("isFetching", false);
    case actions.QUICK_RESPONSE_CREATE_REQUEST:
      return state.set("isFetching", true);
    // ======== UPDATE ==========
    case actions.QUICK_RESPONSE_UPDATE_SUCCESS:
      //Needs this cluster to find the index because of LIST
      const itemList = state.get("items");
      let itemIndex;

      itemList.forEach((item, index) => {
        if (item.id === action.id) {
          itemIndex = index;
        }
      });
      return state
        .set("isFetching", false)
        .setIn(["items", itemIndex], action.quickResponse);
    case actions.QUICK_RESPONSE_UPDATE_FAILURE:
      return state.set("isFetching", false);
    case actions.QUICK_RESPONSE_UPDATE_REQUEST:
      return state.set("isFetching", true);
    // ======== DELETE ==========
    case actions.QUICK_RESPONSE_DELETE_SUCCESS:
      return state
        .set("isFetching", false)
        .update("items", (list) =>
          list.filter((item) => item.id !== action.id)
        );
    case actions.QUICK_RESPONSE_DELETE_FAILURE:
      return state.set("isFetching", false);
    case actions.QUICK_RESPONSE_DELETE_REQUEST:
      return state.set("isFetching", true);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/model/QuickResponse/reducer.js